/**
 * Admin-only inquiry routing trace display helpers.
 */

export const ADMIN_INQUIRY_TRACE_CARD_TEST_ID = 'admin-inquiry-routing-trace-card';
export const ADMIN_QA_OWNER_LISTINGS_CARD_TEST_ID = 'admin-qa-owner-listings-card';

export const ROUTING_HEALTH_HEALTHY = 'healthy';
export const ROUTING_HEALTH_WARNING = 'warning';
export const ROUTING_HEALTH_ERROR = 'error';

export function getRoutingHealthLabel(health, t) {
  const value = String(health || '').toLowerCase();
  if (value === ROUTING_HEALTH_HEALTHY) {
    return t('admin.inquiry_trace_health_healthy', 'Healthy');
  }
  if (value === ROUTING_HEALTH_WARNING) {
    return t('admin.inquiry_trace_health_warning', 'Warning');
  }
  if (value === ROUTING_HEALTH_ERROR) {
    return t('admin.inquiry_trace_health_error', 'Error');
  }
  return t('admin.inquiry_trace_health_unknown', 'Unknown');
}

export function getRoutingHealthBadgeClass(health) {
  const value = String(health || '').toLowerCase();
  if (value === ROUTING_HEALTH_HEALTHY) {
    return 'bg-emerald-100 text-emerald-800 border-emerald-200';
  }
  if (value === ROUTING_HEALTH_WARNING) {
    return 'bg-amber-100 text-amber-800 border-amber-200';
  }
  if (value === ROUTING_HEALTH_ERROR) {
    return 'bg-red-100 text-red-800 border-red-200';
  }
  return 'bg-slate-100 text-slate-700 border-slate-200';
}

export function formatTraceTimestamp(value, locale) {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  return date.toLocaleString(locale || 'en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function safeAdminEmailRef(trace) {
  const email = trace?.guest?.email;
  if (!email) {
    return trace?.inquiry_ref || '—';
  }
  const at = email.indexOf('@');
  if (at <= 1) {
    return email;
  }
  return `${email.slice(0, 2)}…${email.slice(at)}`;
}

export function safeOwnerEmailRef(trace) {
  const email = trace?.routing?.owner_email;
  if (!email) {
    return trace?.routing?.resolved_owner_id?.slice(0, 8) || '—';
  }
  const at = email.indexOf('@');
  if (at <= 1) {
    return email;
  }
  return `${email.slice(0, 2)}…${email.slice(at)}`;
}

export function summarizeMismatchFlags(trace, t) {
  const flags = Array.isArray(trace?.mismatch_flags) ? trace.mismatch_flags : [];
  if (flags.length === 0) {
    return '';
  }
  return flags
    .map((flag) => t(`admin.inquiry_trace_flag_${flag}`, flag.replace(/_/g, ' ')))
    .join(', ');
}

export function qaOwnerMatchLabel(trace, t) {
  const qa = trace?.qa;
  if (!qa || !qa.qa_owner_found) {
    return t('admin.inquiry_trace_qa_owner_unconfigured', 'QA owner not configured');
  }
  if (qa.routed_owner_matches_qa_owner) {
    return t('admin.inquiry_trace_qa_owner_yes', 'Matches Temp Owner: yes');
  }
  return t('admin.inquiry_trace_qa_owner_no', 'Matches Temp Owner: no');
}

export function qaOwnerMatchClass(trace) {
  const qa = trace?.qa;
  if (!qa || !qa.qa_owner_found) {
    return 'text-slate-500';
  }
  return qa.routed_owner_matches_qa_owner ? 'text-emerald-700' : 'text-amber-700';
}

export function qaOwnerMismatchExplanation(trace, t) {
  const text = trace?.qa?.explanation;
  if (!text) {
    return '';
  }
  return t('admin.inquiry_trace_qa_mismatch_explanation', text);
}
